// Lab sample type pages
const PrepScheduleIndex = () => import('@/pages/lab/prepschedule/PrepScheduleIndex');
const PrepScheduleManage = () => import('@/pages/lab/prepschedule/PrepScheduleManage');
const PrepScheduleManageSamples = () => import('@/pages/lab/prepschedule/PrepScheduleManageSamples');
const PrepScheduleManageInstrumentInstances = () => import('@/pages/lab/prepschedule/PrepScheduleManageInstrumentInstances');

/**
 * SubmissionQuestion route definitions
 */
export class PrepScheduleRoutes {

  constructor() {

    // define vars
    this.route_root = 'prep-schedules/';
    this.type_single = 'Prep Schedule';
    this.type_plural = 'Prep Schedules';

    /**
     * Define routes array
     * @type {*[]}
     */
    this.routes = [
      {
        path: this.route_root,
        name: 'Find ' + this.type_single,
        component: PrepScheduleIndex,
        meta: {requiresAuth: true}
      },
      {
        path: this.route_root + '/:prep_schedule_id/manage',
        name: 'Manage ' + this.type_single,
        component: PrepScheduleManage,
        meta: {requiresAuth: true}
      },
      {
        path: this.route_root + '/:prep_schedule_id/manage/samples',
        name: 'Manage ' + this.type_single + ' Samples',
        component: PrepScheduleManageSamples,
        meta: {requiresAuth: true}
      },
      {
        path: this.route_root + '/:prep_schedule_id/manage/instrument-instances',
        name: 'Manage ' + this.type_single + ' Instruments',
        component: PrepScheduleManageInstrumentInstances,
        meta: {requiresAuth: true}
      },
    ];

    /**
     * Define public routes array
     * @type {Array}
     */
    this.public_routes = [];
  }

  /**
   * Fetch rout definitions statically
   * @returns {*[]|*}
   */
  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  /**
   * Fetch public routes array
   * @returns {Array}
   */
  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}

